import EventTypes from "@wesstron/utils/Api/constants/eventTypes";

export function shouldIncludeInGainChart(event) {
    if (event?.DtaDelTime) {
        return false;
    }
    switch (event?.EvCode) {
        case EventTypes.INSERTION:
            return true;
        case EventTypes.WEIGHTING:
            // ważenie automatyczne ma być wyłączone zgodnie z issue #12270
            return event.EvData?.OperID?.toLowerCase?.() !== "system";
        default:
            return false;
    }
}

export function shouldIncludeInWeightingChart(event) {
    if (event?.DtaDelTime) {
        return false;
    }
    switch (event?.EvCode) {
        case EventTypes.SELL:
            return true;
        case EventTypes.FALL:
            return true;
        default:
            return shouldIncludeInGainChart(event);
    }
}
